import classNames from 'classnames';
import React, { useCallback, useRef, useState, useEffect } from 'react';
import style from './DepreciationScheduleManagementTable.module.scss';
import InitTable, { Query } from '../Table/Table';
import { Link, useParams } from 'react-router-dom';
import { getDepreciationSchedules } from '../../services';
import { DepreciationSchedule, IToastMessage } from '../../interface';
import _ from 'lodash';


const { Table, Column, TopBar } = InitTable<DepreciationSchedule>();

interface Props {
  className?: string;
  setToastMessage?: React.Dispatch<React.SetStateAction<IToastMessage | undefined>>;
}


function DepreciationScheduleManagementTable(props: Props) {
  const params = useParams();
  const [depreciationSchedules, setDepreciationSchedules] = useState<DepreciationSchedule[]>([])
  
  //Pagination
  const [total, setTotal] = useState<number>(0);
  const [fetchingData, setFetchingData] = useState(false);
  const previousQuery = useRef<Query | undefined>(undefined)

  useEffect(() => {
    fetchData(previousQuery.current);
  }, [params.id]);

  const fetchData = useCallback((query?: Query) => {
    if (!params.id) {
      return;
    }

    previousQuery.current = query;
    setFetchingData(true);
    getDepreciationSchedules({
      depreciationScheduleCollectionId: _.toNumber(params.id),
      sortBy: _.last(_.keys(query?.order)),
      sortDirection: _.last(_.values(query?.order)),
      page: query?.pagination?.page ?? 1,
      perPage: query?.pagination?.pageSize ?? 10,
    })
      .then((res) => {
        setDepreciationSchedules(res.data.items);
        setTotal(res.data.total);
        setFetchingData(false);
      })
      .catch(() => {
        setFetchingData(false);
      });

  }, []);

  return (
    <div className={
      classNames(
        props.className,
        style['main-content'],
        'd-flex flex-column'
      )
    }>
      <Table
        id='DepreciationScheduleManagementTable'
        rows={depreciationSchedules}
        onQueryChanged={fetchData}
        paginate
        sortable
        totalRows={total}
        loading={fetchingData}
      >
        <TopBar>
          <h3 className={style.textTitle}>Depreciation Schedules</h3>
        </TopBar>
        {/* Schedule Name */}
        <Column
          label='Schedule Name'
          id='name'
        >
          {
            (row: DepreciationSchedule) => (
              <span><strong>{row.name}</strong></span>
            )
          }
        </Column>

        {/* Actions column  */}
        <Column
          id='actions'
          label='Actions'
          sortable={false}
        >
          {(data: DepreciationSchedule) => (
            <div className={classNames(style['operate'], 'd-flex')}>
              <Link
                to={`/admin/depreciation-schedule-management/${data.id}/view`}
                className='view'
              />
            </div>
          )}
        </Column>
      </Table>
    </div>
  );
}

export default DepreciationScheduleManagementTable;